import Chip from '@components/Chip';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

function SendMethod() {
    const { t } = useTranslation('gift');
    return (
        <Column fullWidth spacing={22}>
            <Text color={colors.gray7} fontWeight='bold' size='2xl'>
                {t('giftOrder.sendMethod')}
            </Text>
            <ChipContainer>
                <Chip isSelected>{t('giftOrder.sms')}</Chip>
            </ChipContainer>
        </Column>
    );
}

const ChipContainer = styled(Chip.Container)`
    margin-bottom: -2px;
    margin-left: -2px;
    padding: 2px;
`;

export default SendMethod;
